const utmTags = [
  "utm_adgroup",
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term",
  "gclid",
];

type TKeyTags = (typeof utmTags)[number];

export const setUtmTagsToStorage = (searchParams: URLSearchParams) => {
  const result = utmTags.reduce<Record<TKeyTags, string>>((acc, tag) => {
    const value = searchParams.get(tag);
    if (value) {
      acc[tag] = value;
    }

    return acc;
  }, {});

  if (Object.keys(result).length) {
    window.sessionStorage.setItem("utmTags", JSON.stringify(result));
  }
};

export const removeUtmTagsFromSearchParams = (searchParams: string) => {
  const path = searchParams.includes("?") ? searchParams.split("?")[0] : searchParams;
  const queryString = searchParams.includes("?") ? searchParams.split("?")[1] : "";
  const urlSearchParams = new URLSearchParams(queryString);

  utmTags.forEach((tag) => {
    urlSearchParams.delete(tag);
  });

  return urlSearchParams.toString() ? `${path}?${urlSearchParams.toString()}` : path;
};
